import React from 'react';
import { connect } from 'react-redux';

const PublishModal = (props) => {
    const { 
        showPublishModal,
        setShowPublishModal,
        isPublishable,
        isZeroMediaWarningVisible,
        warningLevel,
        Publish,
        haveCredits,
        allowTopBar,
    } = props;
    return (
        <div className="PublishModal" style={{ display: showPublishModal ? 'flex' : 'none' }}>
            {haveCredits || props.ifloorplanNowState.first_published_datetime ? '' :
                <div className="warning-out-of-credit">
                    <p>You have no credits</p>
                    <a href="/user/purchase" target="_blank">Purchase</a>
                </div>}
            {isZeroMediaWarningVisible ?
                <span className="levelWarning">The Level *{warningLevel[0].level}* has no {warningLevel[0].media}</span>
                : ''}
            <div className="PublishModal-header">
                {(haveCredits || props.ifloorplanNowState.first_published_datetime) ? `Ready to ${props.type_action === "edit" && props.ifloorplanNowState.first_published_datetime ? 'update' : 'Publish'} your iFloorPlan?`
                    : `You need 1 credit to publish`}
            </div>
            {props.type_action === "edit" && props.ifloorplanNowState.first_published_datetime ?
                <div className="UpdateModal-body">
                    <a className="UpdateModal-btn"
                        onClick={async (event) => {
                            if (!isPublishable)
                                event.preventDefault();
                            else if (allowTopBar) {
                                Publish();
                                //window.location.assign('/user/new');
                                setShowPublishModal(false);
                            }
                        }}>
                        <p className={isPublishable ? "UpdateModal-label" : "UpdateModal-label not"}>Update and Republish</p>
                    </a>
                </div>
                :
                <div className="PublishModal-body">
                    <a className="PublishModal-btn"
                        onClick={async (event) => {
                            if (!isPublishable || !haveCredits)
                                event.preventDefault();
                            else if (allowTopBar) {
                                Publish();
                                //window.location.assign('/user/new');
                                setShowPublishModal(false);
                            }
                        }}>
                        <p className={`${isPublishable ? "PublishModal-label" : "PublishModal-label not"} ${!isPublishable || !haveCredits ? "disabled" : ""}`}>
                            Deduct 1 credit and Publish
                        </p>
                    </a>
                </div>}
            <div className={props.type_action === "edit" && props.ifloorplanNowState.first_published_datetime ? "updateModal-footer" : "PublishModal-footer"}>
                <span className="PublishModal-close">
                    <h5 className={haveCredits ? "" : "outofCreditsCancel"}>Cancel and continue editing</h5>
                </span>
            </div>
        </div>
    )
}

const putState = (state) => {
    return {
        ifloorplanNowState: state.ifloorplanNowState,
        type_action: state.type_action,
    }
}

export default connect(putState)(PublishModal);
